module.exports = __webpack_public_path__ + "static/img/cash_300000.43368ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prizes/cash_300000.png
// module id = 70pn
// module chunks = 1